import React from "react"
import { Outlet, type RouteObject } from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import { lazyPage } from "../lazyPage.tsx"
import { ContractsLayout } from "../../../Contracts/components/ContractsLayout.tsx"

const ContractAddPage = lazyPage(
  () => import("../../../Contracts/ContractAddPage/ContractAddPage.tsx")
)
const ContractEditPage = lazyPage(
  () => import("../../../Contracts/ContractEditPage/ContractEditPage.tsx")
)
const ContractViewPage = lazyPage(
  () => import("../../../Contracts/ContractViewPage/ContractViewPage.tsx")
)
const ContractsPage = lazyPage(() =>
  import("../../../Contracts/ContractsPage/ContractsPage.tsx").then((m) => ({
    default: m.ContractsPage
  }))
)
export const contractRoutes: RouteObject[] = [
  {
    element: (
      <PermissionGate paths={["leads.features.lead_contract_approval"]}>
        <Outlet />
      </PermissionGate>
    ),
    children: [
      {
        path: `${RoutesPaths.contract.add}`,
        element: <ContractAddPage />
      },
      {
        path: `${RoutesPaths.contract.edit(":id")}`,
        element: <ContractEditPage />
      },
      {
        path: RoutesPaths.contract.list,
        element: <ContractsLayout />,
        children: [
          { index: true, element: <ContractsPage /> },
          { path: ":id", element: <ContractViewPage /> }
        ]
      }
    ]
  }
]
